import React from 'react';

import styles from './styles.module.scss';

interface LoadingProps {
  isCADashboard?: boolean;
  dotted?: boolean;
  fullScreen?: boolean;
  isHeightAuto?: boolean;
}

export const Loading: React.FC<LoadingProps> = ({
  isCADashboard = false,
  dotted = false,
  fullScreen = false,
  isHeightAuto = false,
}) => {
  return (
    <>
      {fullScreen && (
        <div className={styles.overlay}>
          <div className={styles.ldsEllipsis}>
            <div />
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      {dotted && (
        <div className={styles.ldsEllipsisDiv} style={{ height: isHeightAuto ? 'auto' : '' }}>
          <div className={styles.ldsEllipsis}>
            <div />
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      {isCADashboard && (
        <div className={styles.defaultClass}>
          <div className="spinner-border text-primary" role="status" />
        </div>
      )}
    </>
  );
};
